import { useState } from 'react';
import { FiltersMap, OptionalFiltersMap } from '@wix/bex-core';
import { useWixPatternsContainer } from '@wix/bex-core/react';
import { CardsGridState } from '../state';
import { UseCollectionComponentBaseParams } from './useCollectionComponentBaseParams';

export interface UseGridParams<T, F extends FiltersMap = OptionalFiltersMap>
  extends UseCollectionComponentBaseParams<T, F> {}

export function useGrid<T, F extends FiltersMap = OptionalFiltersMap>({
  collection,
}: UseGridParams<T, F>) {
  const container = useWixPatternsContainer();

  const [state] = useState(
    () =>
      new CardsGridState({
        collection,
        container,
      }),
  );

  return state;
}
